<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  components: {
   
  },

  data: () => ({
    //
  }),
};
</script>
<style>
@font-face {
font-family:'AvenirLTProMedium';
src: url('~@/assets/font/AvenirLTProMedium.otf');
font-weight: normal;
font-style: normal;
}

@font-face {
font-family:'AvenirLTProBookOblique';
src: url('~@/assets/font/AvenirLTProBookOblique.otf');
font-weight: normal;
font-style: normal;
}

@font-face {
font-family:'AvenirLTProHeavy';
src: url('~@/assets/font/AvenirLTProHeavy.otf');
font-weight: normal;
font-style: normal;
}

@font-face {
font-family:'FontsFree-Net-SFProDisplay-Regular';
src: url('~@/assets/font/FontsFree-Net-SFProDisplay-Regular.ttf');
font-weight: normal;
font-style: normal;
}

@font-face {
font-family:'SF-UI-Display-Bold';
src: url('~@/assets/font/SF-UI-Display-Bold.otf');
font-weight: normal;
font-style: normal;
}
@font-face {
font-family:'AvenirLTProBook';
src: url('~@/assets/font/AvenirLTProBook.otf');
font-weight: normal;
font-style: normal;
}
body::-webkit-scrollbar {
  width: 0em;
  
}
body::-webkit-scrollbar-thumb {
  background-color: #ad1684;
  border-radius: 10px;
}
.view-enter-active,
.view-leave-active {
  transition: opacity 0.5s ease-in-out, transform 0.5s ease;
}
.view-enter-active {
  transition-delay: 0.5s;
}
.view-enter {
  opacity: 0;
  transform: translateY(-100px);
}
.view-enter-to {
  opacity: 1;
  transform: translateY(0px);
}
.view-leave {
  opacity: 1;
  transform: translateY(0px);
}
.view-leave-to {
  opacity: 0;
  transform: translateY(100px);
}
</style>
